import $ from 'jquery';
import '../lib/swiper';
import utils from './utils';
import Player from 'silent-film-player';

import '../img/pc/part1/part1-bg.jpg';
import '../img/m/part1/m_part1-bg.png';

import '../img/slider/game-slider-1.jpg';
import '../img/slider/game-slider-2.jpg';
import '../img/slider/game-slider-3.jpg';
import '../img/slider/game-slider-4.jpg';
import '../img/slider/game-slider-5.jpg';
import '../img/slider/real-slider-1.jpg';
import '../img/slider/real-slider-2.jpg';
import '../img/slider/real-slider-3.jpg';
import '../img/slider/real-slider-4.jpg';
import '../img/slider/real-slider-5.jpg';
import '../img/slider/real-slider-6.jpg';
import '../img/slider/real-slider-7.jpg';

const sliderImage1 = ['game-slider-1.jpg', 'game-slider-2.jpg', 'game-slider-3.jpg', 'game-slider-4.jpg', 'game-slider-5.jpg'];
const sliderImage2 = ['real-slider-1.jpg', 'real-slider-2.jpg', 'real-slider-3.jpg', 'real-slider-4.jpg', 'real-slider-5.jpg', 'real-slider-6.jpg', 'real-slider-7.jpg'];

const shareInfo = {
  title: encodeURIComponent('【公式】MU：アークエンジェル'),
  message: encodeURIComponent('【公式】MU：アークエンジェル'),
  id: 352813742852578,
  img: encodeURIComponent(''),
};

function login() {
  return new Promise(function (resolve, reject) {
    FB.login(function (response) {
      response.status == "connected" ? (fbState = true && resolve()) : reject();
    });
  });
};

function execSharePopup() {
  return new Promise(function (resolve, reject) {
    var url = encodeURIComponent('https://jp.37games.com/musjp/index.html?aid=musjp&cid=share&scid=fb');
    var host = window.location.host.match(/\.(.*)\.com/)[1];
    var data = {
      method: "share",
      href:
        "https://geventsapi." + host + ".com/fbShareCustomize/customizeShare/message/" +
        shareInfo.message +
        "/app_id/" +
        shareInfo.id +
        "/share_title/" +
        shareInfo.title +
        "/redict_url/" +
        url +
        "/pic_url/" +
        shareInfo.img
    };
    FB.ui(data, function (res) {
      (res && !res.error_message) ? resolve() : reject();
    });
  });
};

function getLoginStatus() {
  return new Promise(function (resolve) {
    FB.getLoginStatus(function (response) {
      fbState = response.status === "connected";
      resolve();
    });
  });
}

// 调起分享
function share() {
  try {
    if (fbState) {
      execSharePopup()
      return;
    }
    login().then(function () {
      execSharePopup()
      getLoginStatus();
    })
  } catch (e) {
    throw new Error(e);
  }
};

const getParam = (name, href) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var realparams = window.location.search.substr(1);
  if (href && href.indexOf("?") > -1) {
    realparams = href.split("?")[1];
  }
  var r = realparams.match(reg);

  if (r != null) return decodeURIComponent(r[2]);
  return '';
}

// 双端公共页面静态部分
const commonStatic = {
  isPC: true,
  boolNavShow: false,
  $menuSwitch: $('.j-menu-switch'),
  $mNav: $('.j-nav'),
  $newsBar: $('.j-news-bar'),
  $newsContent: [$('.j-news-content-1'), $('.j-news-content-2'), $('.j-news-content-3'), $('.j-news-content-4')],
  $newsBarLink: $('.j-news-bar-link'),
  $part1: document.querySelector('.j-part1'),
  $part2: document.querySelector('.j-part2'),
  $part3: document.querySelector('.j-part3'),
  $part4: document.querySelector('.j-part4'),
  $video: $('.j-video'),
  $navList: $('.j-nav-list'),
  $navItem: $('.j-nav-list .list-item'),
  $download: $('.j-download'),
  newsSlider: null,
  roleSwiper: null,
  shopSwiper1: null,
  shopSwiper2: null,
  navHeight: 0,
  pageLocation: {
    part1: 0,
    part2: 0,
    part3: 0,
    part4: 0
  },
  init(isPC) {
    dataLayer.push({
      event: 'entrance',
      scid: getParam('scid'),
      cid: getParam('cid')
    });
    this.isPC = isPC;
    $(() => {
      let boolInit = false;
      this.isPC && $('.j-real-video').on('canplaythrough', () => {
        if (boolInit) {
          return;
        }
        boolInit = true;
        this.lazyInit.call(this, this.isPC);
      })
      !this.isPC && this.initVideo(this.lazyInit.bind(this));
      // this.lazyInit();
    })
  },
  async lazyInit() {
    $('.j-menu-download').on('click', () => {
      utils.deviceType() === 'ios' ?
        window.open('//apps.apple.com/jp/app/id1570592177', '_blank') :
        window.open('//play.google.com/store/apps/details?id=com.global.musjp', '_blank');
    })

    !this.isPC && this.initSwitchMenu();

    this.initDownload();
    this.initMenu(this.isPC);
    this.initNewsSlider();
    this.initRoleSlider();
    this.initShopSlider();
    this.updatePageLocation();
    this.locatePage();
    this.initNewsTab();

    // FB分享
    $('.j-share-fb').on('click', () => {
      share();
    })
    // 推特分享 监听
    twttr.events.bind(
      'tweet',
      function (event) {
        dataLayer.push({ 'event': 'creatEvt', 'eventName': '推特分享', });
      }
    );
    // 防抖处理
    window.addEventListener('resize', utils.antiShake(() => {
      this.updatePageLocation();
    }));
    // 节流处理
    window.addEventListener('scroll', utils.throttle(() => {
      this.changeNavActive([this.$part1, this.$part2, this.$part3, this.$part4]);
    }))
  },
  initTWShare() {
    twttr.widgets.createMentionButton(
      'MUArchangel_JP',
      document.getElementById('j-btn-tw'),
      {
        text: '【公式】MU：アークエンジェル',
        size: 'large',
        url: 'https://jp.37games.com/musjp/index.html?aid=musjp&cid=share&scid=tw'
      }
    )
  },
  initVideo(cb) {
    const canvas = document.querySelector('#bgvideo');
    const url = `//${window.location.host}/musjp/m_home.ts`;
    let boolInit = false;
    new Player(url, {
      canvas,
      poster: `//${window.location.host}/musjp/img/m_part1-bg.png`, // 输入视频未加载时显示的图片url
      loop: true, // 循环播放
      autoplay: true, // 自动播放
      progressive: true, // 渐进播放
      // 是否启用 wasm 解码，一般选true
      disableWebAssembly: true,
      chunkSize: 1 * 1024 * 1024,
      videoBufferSize: 1 * 1024 * 1024,
      onPlay: () => { // 开始播放的回调
        if (boolInit) {
          return;
        }
        boolInit = true;
        canvas.style.opacity = '1';
        cb && typeof cb === 'function' && cb();
      }
    });
  },
  initSwitchMenu() {
    const _self = this;
    let countTwInit = 0;
    this.$menuSwitch.on('click', function () {
      if (_self.boolNavShow) {
        $(this).removeClass('active');
        _self.$mNav.fadeOut(100);
        _self.boolNavShow = false;
      } else {
        $(this).addClass('active');
        _self.$mNav.fadeIn(100);
        _self.boolNavShow = true;
        countTwInit < 1 ? _self.initTWShare() || countTwInit++ : '';
      }
    })
  },
  closeMenu() {
    if (!this.isPC && this.$mNav) {
      this.$mNav.fadeOut(100)
      this.$menuSwitch.removeClass('active');
      this.boolNavShow = false;
    }
  },
  initMenu() {
    this.$navList.on('click', ({ target }) => {
      const index = target.dataset.index * 1;
      if (!index) {
        return;
      }
      if (index == 5) {
        window.open('//gabres.37games.com/platform/webSupport.html?gameId=255&language=ja-JP#/', '_blank');
        this.closeMenu();
        return;
      }
      this.scrollPage(index);
    })
  },
  locatePage() {
    let hash = window.location.hash.replace('#', '') * 1;
    let index = hash > 0 && hash < 5 ? hash : 1;
    this.scrollPage(index);
  },
  scrollPage(index) {
    let top = this.pageLocation[`part${index}`];
    index != 1 && (top -= this.navHeight);
    this.$navItem
      .removeClass('active')
      .eq(index - 1)
      .addClass('active');
    window.scrollTo({
      top,
      behavior: "smooth"
    });
    this.closeMenu();
  },
  changeNavActive(parts = []) {
    let index = 0;
    for (let i = 0; i < parts.length; i++) {
      let bool = utils.computeEleShow(parts[i]);
      if (bool) {
        index = i + 1;
        break;
      }
    }
    index > 1 ? this.$download.fadeIn(160) : this.$download.fadeOut(160);
    this.$navItem
      .removeClass('active')
      .eq(index - 1)
      .addClass('active');
    dataLayer.push({ 'event': `showPage${index}` });
  },
  initDownload() {
    utils.deviceType() == 'ios' ?
      $('.j-apple').css('display', 'block') :
      $('.j-google').css('display', 'block');
  },
  initRoleSlider() {
    this.roleSwiper = new Swiper('.part3-main .swiper-container', {
      loop: true,
      autoplay: true,
      navigation: {
        nextEl: '.part3-main .swiper-button-next',
        prevEl: '.part3-main .swiper-button-prev',
      },
      pagination: {
        clickable: true,
        el: '.part3-main .swiper-pagination',
      },
    });
  },
  initNewsTab() {
    this.$newsBar.on('click', ({ target }) => {
      let index = target.dataset.index;
      if (index >= 0 && index < 4) {
        this.$newsContent.forEach((item) => {
          item.hide();
        })
        this.$newsBarLink.removeClass('active');
        this.$newsBarLink.eq(index).addClass('active');
        this.$newsContent[index].show();
        return;
      }
      if (index == 4) {
        window.open('//jp.37games.com/musjp/list.html', '_blank');
      }
    })
  },
  async initNewsSlider() {
    this.newsSlider = new Swiper('.part2 .swiper-container', {
      loop: true,
      autoplay: true,
      pagination: {
        el: '.part2 .swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          let myClassName = 'point' + index + 1;
          return '<span class="' + className + ' ' + myClassName + '"></span>';
        },
      },
    });
    window.newsSlider = this.newsSlider;
  },
  async initShopSlider() {
    // 初始化商品轮播1
    this.shopSwiper1 = new Swiper('.part4 .slider-1 .swiper-container', {
      loop: true,
      autoplay: true,
      pagination: {
        el: '.swiper-pagination1',
        clickable: true,
        renderBullet: function (index, className) {
          let myClassName = 'point' + index + 1;
          return '<span class="' + className + ' ' + myClassName + '"></span>';
        },
      },
    });
    // 初始化商品轮播2
    this.shopSwiper2 = new Swiper('.part4 .slider-2 .swiper-container', {
      loop: true,
      autoplay: true,
      pagination: {
        el: '.swiper-pagination2',
        clickable: true,
        renderBullet: function (index, className) {
          let myClassName = 'point' + index + 1;
          return '<span class="' + className + ' ' + myClassName + '"></span>';
        },
      },
    });
    // 轮播切换
    const $gameSliderBtn = $('.j-btn-1');
    const $realSliderBtn = $('.j-btn-2');
    const $gameSlider = $('.j-slider-1');
    const $realSlider = $('.j-slider-2');
    const $gamePahination = $('.j-swiper-pagination1');
    const $realPahination = $('.j-swiper-pagination2');
    $gameSliderBtn.on('click', () => {
      $gameSlider.fadeIn();
      $gamePahination.fadeIn();
      $realSlider.fadeOut();
      $realPahination.fadeOut();
      this.shopSwiper1.update();
    })
    $realSliderBtn.on('click', () => {
      $realSlider.fadeIn();
      $realPahination.fadeIn();
      $gameSlider.fadeOut();
      $gamePahination.fadeOut();
      this.shopSwiper2.update();
    })
  },
  updatePageLocation() {
    let navClass = this.isPC ? '.j-nav' : '.j-menu';
    this.navHeight = document.querySelector(navClass).getBoundingClientRect().height;
    for (let i = 0; i < 4; i++) {
      this.pageLocation[`part${i + 1}`] = utils.computeEleLocation(this[`$part${i + 1}`]);
    }
  }
}


export default commonStatic;
